<script setup lang="ts">
import { DiagnosticStatusIcons, IsOkStatus, PartDiagnosticStatus } from '@/types/rc/miners/PartStatus'
defineProps<{ status: PartDiagnosticStatus; tooltip?: string }>()
</script>

<template>
  <ElTooltip v-if="tooltip" :content="tooltip" :enterable="false" effect="dark">
    <ElButton :icon="DiagnosticStatusIcons[status]" :class="['btn-status', { ok: IsOkStatus[status] }]" link>
      {{ status }}
    </ElButton>
  </ElTooltip>
  <ElButton v-else :icon="DiagnosticStatusIcons[status]" :class="['btn-status', { ok: IsOkStatus[status] }]" link>
    {{ status }}
  </ElButton>
</template>
